module.exports = {
          srcSet: __webpack_public_path__ + "860eba34f47697ba25511a4dc4c4de60-129.png"+" 129w",
          images:[ {path: __webpack_public_path__ + "860eba34f47697ba25511a4dc4c4de60-129.png",width: 129,height: 40}],
          src: __webpack_public_path__ + "860eba34f47697ba25511a4dc4c4de60-129.png",
          toString:function(){return __webpack_public_path__ + "860eba34f47697ba25511a4dc4c4de60-129.png"},
          
          width: 129,
          height: 40
        }